import { defineMessages } from 'react-intl';

const messages = defineMessages({
  itemSku: {
    description: 'advancedSearch.orders.filters.itemSku',
    defaultMessage: 'Item SKU',
    id: 'j8Jc0W',
  },
});

export default messages;
